import { render } from "./OperationalUnitAssignment.vue?vue&type=template&id=179e010c&scoped=true"
import script from "./OperationalUnitAssignment.vue?vue&type=script&lang=js"
export * from "./OperationalUnitAssignment.vue?vue&type=script&lang=js"

import "./OperationalUnitAssignment.vue?vue&type=style&index=0&id=179e010c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-179e010c"]])

export default __exports__